$(function () {
    $.validator.setDefaults({
        ignore: null,
    });

    // Initialize options drop down
    $("#options").on("change", function () {
        var productId = $(this).val();
        var product = _.find(puritanLawn.model.data.Products, function(product) {
            return product.Id == productId; 
        });

        var imageFileName = (product.ImageExists) ? product.ImageFileName : "placeholder.gif";
        var src = puritanLawn.viewModel.imagePathRoot + "/" + imageFileName;

        $("#image").attr("src", src);
        $("#product-description").html(product.Description || '');
        var displayPrice = (typeof product.DisplayUnitPrice === "number") ? product.DisplayUnitPrice : product.Price;
        $("#productPriceDisplay").text(displayPrice.toFixed(2));
        $("#productPriceHidden").val(displayPrice);

        puritanLawn.viewModel.productId = product.Id;
        puritanLawn.viewModel.productName = product.Name;
    });

    // Initialize regarding button
    $("#regardingButton").on("click", function () {
        puritanLawn.search.show("Deceased Record Search", (deceasedId, deceasedLFM) => {
            puritanLawn.viewModel.regardingDeceasedId = deceasedId;
            puritanLawn.viewModel.regardingDeceasedLFM = deceasedLFM;
            $("#regardingDeceasedLFMDisplay").text(deceasedLFM);
            $("#regardingDeceasedLFMDisplay").removeClass("text-danger");
        });
    });

    // Initialize add to cart button
    $("#addToCartButton").on("click", function () {
        // Calling the function in this manner ensures the "this" reference in the function references the triggering button
        AddToOrUpdateInCart.call(this);
    });

    $("#updateInCartButton").on("click", function () {
        // Calling the function in this manner ensures the "this" reference in the function references the triggering button
        AddToOrUpdateInCart.call(this);
    });

    $("#cancelButton").on("click", function () {
        window.location.href = "/Order/ShoppingCart";
    });
});

async function AddToOrUpdateInCart() {
    var isInvalid = false;

    $("#regardingDeceasedLFMDisplay").removeClass("text-danger");
    $("#priceLabel").removeClass("text-danger");
    $("#productTypeDeliveryTypes .form-check-label").removeClass("text-danger");

    // Validate amount (If required)
    var inNameOf = puritanLawn.viewModel.inNameOf;
    var $fixedPrice = $("#productPriceHidden");
    var price = $fixedPrice.length ? $fixedPrice.val() : $("#price").val();

    if (inNameOf) {
        if (price === '' || isNaN(price)) {
            $("#priceLabel").addClass("text-danger");
            isInvalid = true;
        }
    }

    // Validate regarding deceased (If required)
    var requiresDeceased = puritanLawn.viewModel.requiresDeceased;
    var deceasedId = puritanLawn.viewModel.regardingDeceasedId;

    if (requiresDeceased) {
        if (deceasedId == null || deceasedId === undefined || deceasedId == "") {
            $("#regardingDeceasedLFMDisplay").addClass("text-danger");
            isInvalid = true;
        }
    }

    // Validate delivery type
    var productTypeDeliveryTypeElementType = ((puritanLawn.viewModel.isMultiOccassion) ? "checkbox" : "radio");
    var productTypeDeliveryTypeElements = $("#productTypeDeliveryTypes input[type='" + productTypeDeliveryTypeElementType + "']:checked");
    var productTypeDeliveryTypeIds = [];

    if (puritanLawn.viewModel.isDeliverable) {
        if (productTypeDeliveryTypeElements.length == 0) {
            $("#productTypeDeliveryTypes .form-check-label").addClass("text-danger");
            isInvalid = true;
        }
        else {
            _.each(productTypeDeliveryTypeElements, function (productTypeDeliveryTypeElement) {
                productTypeDeliveryTypeIds.push($(productTypeDeliveryTypeElement).val());
            });
        }
    }
    else {
        productTypeDeliveryTypeIds.push(0);
    }

    if (isInvalid) return;

    var i;
    var processed = 0;

    for (i = 0; i < productTypeDeliveryTypeIds.length; i++) {
        let promise = new Promise((resolve, reject) => {
            var formData = new FormData();
            var uscpIdentifier = $(this).data("pl-uscpidentifier");
            var productId = puritanLawn.viewModel.productId;
            var productTypeId = puritanLawn.viewModel.productTypeId;
            var productName = puritanLawn.viewModel.productName;
            var productTypeDeliveryTypeId = productTypeDeliveryTypeIds[i];
            var deceasedLFM = puritanLawn.viewModel.regardingDeceasedLFM;
            var comment = $("#comment").val();

            formData.append("USCPIdentifier", uscpIdentifier);
            formData.append("productId", productId);
            formData.append("productTypeId", productTypeId);
            formData.append("productName", productName);
            formData.append("price", price);
            formData.append("deceasedId", deceasedId);
            formData.append("productTypeDeliveryTypeId", productTypeDeliveryTypeId);
            formData.append("deceasedLFM", deceasedLFM);
            formData.append("comment", comment);

            puritanLawn.ajaxPostMultiPartFormData(puritanLawn.orderServicesBaseAddress + 'AddToOrUpdateInShoppingCart',
                formData,
                (result) => {
                    processed++;

                    if (processed < productTypeDeliveryTypeIds.length) {
                        resolve();
                        return;
                    }

                    var cartCount = result.cartCount;

                    $(".shopping-cart-count").text(cartCount);

                    if (requiresDeceased) {
                        puritanLawn.showThreeButtonModal("Shopping Cart",
                            "<b>" + productName + "</b> has been added to your shopping cart!<br/><br/>Would you like to add another remembrance for <b>" + deceasedLFM + "</b>?",
                            "Yes",
                            () => {
                                window.location.href = "/Order/Products?productTypeIds=4,9,10,11,12&regardingDeceasedId=" + deceasedId;
                            },
                            "No",
                            null,
                            "View Cart",
                            () => {
                                window.location.href = "/Order/ShoppingCart";
                            });
                    }
                    else {
                        puritanLawn.showTwoButtonModal("Shopping Cart",
                            "<b>" + productName + "</b> has been added to your shopping cart!",
                            "OK",
                            null,
                            "View Cart",
                            () => {
                                window.location.href = "/Order/ShoppingCart";
                            });
                    }

                    resolve();
                },
                (response) => {
                    processed++;

                    alert("An error has occurred!");

                    reject();
                }
            );
        });

        await promise;
    }
}